import { createAction, props } from '@ngrx/store';

import { Folder } from '@lockton-apps/shared/interfaces';
import { DocumentModel } from '@lockton-apps/client-gateway/interfaces';

import { FoldersApiActionTypes } from './actions.model';

export const clientFoldersLoadedSuccess = createAction(
  FoldersApiActionTypes.ClientFoldersLoadedSuccess,
  props<{ folders: Folder[] }>()
);

export const clientFoldersLoadedFailure = createAction(
  FoldersApiActionTypes.ClientFoldersLoadedFailure,
  props<{ error: any }>()
);

export const addedSuccess = createAction(
  FoldersApiActionTypes.AddedSuccess,
  props<{ folder: Folder; documents?: DocumentModel[] }>()
);

export const addedFailure = createAction(
  FoldersApiActionTypes.AddedFailure,
  props<{ error: any }>()
);

export const updatedSuccess = createAction(
  FoldersApiActionTypes.UpdatedSuccess
);

export const updatedFailure = createAction(
  FoldersApiActionTypes.UpdatedFailure
);

export const deletedSuccess = createAction(
  FoldersApiActionTypes.DeletedSuccess
);

export const deletedFailure = createAction(
  FoldersApiActionTypes.DeletedFailure
);
